<template>
  <div class="content importList import-box import_new_wrap">
    <div class="title-box">
      <el-button type="default"  v-show="$route.query.guid" size="small" @click="$router.go(-1)">返回</el-button>
      <div class="search-area-title">{{ surveyName || '问卷调查导入' }}</div>
    </div>
    <!-- <div class="import-back" @click="$router.go(-1)"><i class="el-icon-arrow-left" style="padding-right: 10px"></i> 返回</div>
    <div class="search-area-title">问卷调查导入</div>  -->
    <!-- <div class="import-title">
      <div class="import-back" @click="$router.go(-1)"><i class="el-icon-arrow-left" style="padding-right: 10px"></i> 返回</div>
      <span>{{ surveyName || '问卷调查导入' }}</span>
    </div> -->
    <div class="import-tab-box">
      <div
        :class="tabIndex == index ? 'import-tab-list import-tab-active' : 'import-tab-list'"
        v-for="(item, index) in tabList"
        :key="index"
        @click="tabClick(index, item)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="search-area">
      
      <div v-if="tabIndex == 0">
        <div class="ml71">
          <div class="select-list" style="margin-top: 30px">
            <label for=""><span>*</span>选择任务：</label>
            <el-select class="W300" v-model="taskGuid" placeholder="请选择" filterable  :disabled="$route.query.guid?true:false" @change="taskChange">
              <el-option
                v-for="item in taskList"
                :key="item.guid"
                :label="item.taskTitle + ' | ' +item.taskContentName"
                :value="item.guid"
              ></el-option>
            </el-select>
          </div>
          <div class="select-list" style="margin-top: 30px">
            <label for=""><span>*</span>选择问卷：</label>
            <el-select class="W300" v-model="surveyGuid" @change="surveyChange" placeholder="请选择" :disabled="$route.query.surveyGuid?true:false">
              <el-option
                v-for="item in surveyList"
                :key="item.guid"
                :label="item.surveyTitle"
                :value="item.guid"
              ></el-option>
            </el-select>
            <span class="preview-surey" @click="previewSurey">预览问卷</span>
            <span class="preview-surey" v-loading.fullscreen.lock="fullscreenLoading" v-if="surveyGuid" @click="downloadFiles">下载问卷题目</span>
          </div>
          <div class="select-list">
            <label for="">下载模板：</label>
            <div>
              <el-button plain size="medium" @click="uploadExcel">下载文件模板</el-button>
              <div class="tipInfo">
                注意事项：<br />
                1、请先下载Excel模版，严格按照模板内容填入数据，再上传文件到系统；<br />
                2、若导入问卷标题问卷标题相同的内容，则信息将会覆盖；<br />
              </div>
            </div>
          </div>
          <div class="select-list">
            <label for="">导入文件：</label>
            <div>
              <el-button size="medium" type="info" v-if="!taskGuid || !surveyGuid " @click="clickSubmit">点击上传文件</el-button>
              <el-upload
                v-else
                class="upload-demo"
                action="#"
                ref="upload"
                :before-upload="beforeUpload"
                multiple
                :limit="1"
                accept=".xlsx,.xsl,.xls,.xlsm"
                :auto-upload="false"
                :on-change="changeFile"
                :on-exceed="handleExceed"
              >
                <el-button
                  size="medium"
                  type="info"
                  v-loading.fullscreen.lock="fullscreenLoading"
                  @click="clickSubmit"
                  >点击上传文件</el-button
                >
              </el-upload>
              <div class="tipInfo">
                注意事项：<br />
                1、仅支持excel文件，大小&lt; =5M；<br />
                2、使用 Office 2010 及以上版本，避免出现乱码；<br />
                3、请确保导入文件里面填写的省市区和对照表一致，<span @click="uploadExcelArea">下载省市区对照表</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="mt15 t-right">
          <el-button size="medium" v-show="$route.query.guid" plain @click="$router.go(-1)">取消</el-button>
          <el-button size="medium" type="info" @click="next()">下一步</el-button>
        </div> -->
      </div>
      
      
      <div v-if="active == 1">
        <div class="summary-text-sty">
          <div class="summary-import-result" v-if="dataErrorSum>0">
            <img src="../../assets/images/import_error.png" alt="">
            <div class="summary-import-tip font-S18">数据导入失败，异常条数 {{dataErrorSum}} 条。</div>
          </div>
          <div class="summary-import-result" v-else>
            <img src="../../assets/images/import_ok.png" alt="">
            <div class="summary-import-tip font-S18">数据导入成功，成功导入 {{dataSuccessSum}} 条。</div>
          </div>
          <p v-if="dataErrorSum>0" @click="exportError" v-loading.fullscreen.lock="fullscreenLoading">下载失败数据，修改后可用此表格继续导入哦～</p>
          <div class="close-btn">
            <el-button size="medium" class="w145 mt30" plain @click="returnActive()">关闭</el-button>
          </div>
        </div>
      </div>
      <div v-if="tabIndex==1">
        <div class="button-area mt0">
          <div>
            <el-button size="mini" type="borderGreen" @click="getData(true)">刷新结果</el-button>
            <span style="color:#999;margin-left:10px">请及时刷新查看最终结果</span>
          </div>
          <div class="mr16">
            <el-button size="mini" type="deleteNew" @click="delFile(1)">批量删除</el-button>
          </div>
        </div>
        <!-- 表格 -->
        <div class="back-color-fff content-main-box"  >
          <el-table
            :data="tableData"
            @selection-change="handleSelectionChange"
            border
            v-loading="tableWrapLoading"
            style="width: 100%"
            height="56vh"
            stripe 
            :header-cell-style="{background:'#f4f4f5'}"
          >
            <el-table-column type="selection" width="60" header-align="center" align="center" :selectable="selected"></el-table-column>
            <el-table-column label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                <!-- {{ scope.$index + 1 }} -->
                {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="tenantName"
              label="导入企业"
              header-align="center"
              align="left"
              show-overflow-tooltip
              width="240"
            >
              <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
            </el-table-column>
            <el-table-column
              prop="fileName"
              label="文件名称"
              header-align="center"
              align="left"
              show-overflow-tooltip
              width="240"
            >
              <template slot-scope="scope">{{ scope.row.fileName || '-' }}</template>
            </el-table-column>
            <el-table-column
              prop="importState"
              label="状态"
              header-align="center"
              align="left"
              show-overflow-tooltip
              width="85"
            >
              <template slot-scope="scope">
                <span :class="getStateClass(scope.row.importState)">{{scope.row.importState | importStateNew}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="importMessage"
              label="导入结果"
              header-align="center"
              align="left"
              show-overflow-tooltip
              min-width="250"
            >
              <template slot-scope="scope">{{ scope.row.importMessage || '-' }}</template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="导入时间"
              header-align="center"
              align="left"
              show-overflow-tooltip
              width="140"
            >
              <template slot-scope="scope">{{ scope.row.createTime | getTime}}</template>
            </el-table-column>
            <el-table-column prop="bank" width="230px" label="操作" header-align="center" align="center" fixed="right">
              <template slot-scope="scope">
                <a :class="scope.row.importState == 1 ? 'fontC-bbb cursor-sty' : 'txt-color'" @click="downloadFile(scope.row.filePath, 1,scope.row.importState)">下载文件 </a>
                <a class="txt-color" @click="downloadFile(scope.row.errorFilePath, 2)" v-if="scope.row.importState == -1">
                  ｜下载异常数据</a
                >
                <a class="txt-color" @click="delFile(2, scope.row.guid)" v-if="scope.row.importState !== 1"> ｜删除</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 50, 100, 200]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination>
      </div>
    </div>
    <!-- <el-dialog
      title=""
      :visible.sync="showImport"
      width="560px"
      height="120px"
      :show-close="false"
      :before-close="handleClose"
    >
      <div class="progress-box">
        <p class="mb10 mt0">正在上传：{{ num }}%</p>
        <el-progress :stroke-width="12" :percentage="num"></el-progress>
      </div>
    </el-dialog> -->
    <!-- <div class="model-bg" v-if="showImport">
              <img class="t-center" style="margin-top:15%;" src="../../assets/images/roll.gif" width="40"><br>
              {{num}}%
            </div> -->
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import importCommon from '@/uilt/importCommon';
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      exportUrl: `/${serverConfig.msCommonImportDataService}/import-data/import-common-unfixed`,
      exportCheckUrl: `/${serverConfig.msSalesPerformService}/import-data-new/import-staff-survey-check`,
      tabList: [
        // { name: '销售订单导入', importType: '0017', templateUrl: '/销售订单导入模板.xlsx' },
        { name: '导入数据' },
        { name: '导入进度' },
      ],
      tabIndex: 0,
      tableWrapLoading:false,
      url:
        `/${serverConfig.msSalesPerformService}/survey/import/excel?tenantGuid=` + this.$store.state.guid,
      active: 0,
      surveyGuid:'',
      surveyName:'',
      surveyList:[],
      taskList:[],
      taskGuid:'',
      progressGuid:'',
      organisationGuid:null,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        importType: '0037',
        errorFlag: '',
      },
      fileList: [],
      showImport: false,
      importSum: 0,
      loading: true,
      tableData: [],
      provinceList: areaJson,
      cityList: [],
      districtList: [],
      companyList:[],
      tenantGuid:'',
      errorRows: 0,
      totalRows: 0,
      fullscreenLoading: false,
      dataAllSum: 0,
      dataSuccessSum: 0,
      dataErrorSum: 0,
      msg: '',
      num: 0,
      intervalSum: '',
      hasStaffColumn:'Y',
      taskDetailGuid:'',
      multipleSelection: [],
    };
  },
  created() {
    // this.getSurveyList();
    if(this.$route.query.guid){
      this.hasStaffColumn = 'N';
    }
    this.getTaskList()
  },
  methods: {
    surveyChange(val){
      this.surveyName=this.surveyList.filter(i=>i.guid==val)[0].surveyTitle
    },
    tabClick(index, item) {
      this.tabIndex = index;
      this.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      let query = JSON.parse(JSON.stringify(self.page));
      // query.accountMonth = query.accountMonth.replace('-', '');
      let userInfo = JSON.parse(localStorage.userInfo);
      query.staffGuid=userInfo.staffGuid
      self.tableWrapLoading = true;
      self.api
        .postJson(`/${serverConfig.msCommonImportDataService}/import-data/list`, query)
        .then(res => {
          self.tableWrapLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.records || [];
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          self.tableWrapLoading = false;
        });
    },
    returnActive() {
      this.active = 0;
      this.surveyGuid = null;
      this.taskGuid = null;
      this.fileList = [];
      if(this.$route.query.guid){
        this.$router.go(-1)
      }
    },
    downloadFiles() {
      let surveyItem = this.surveyList.find(item=>item.guid === this.surveyGuid)
      let param = {
        tenantGuid: localStorage.guid,
        surveyGuid: this.surveyGuid,
        taskDetailGuid : this.$route.query.taskDetailGuid || this.taskDetailGuid,
        organisationGuid : this.organisationGuid
      }
      this.fullscreenLoading = true;
      this.api.postJsonD(`/${serverConfig.msSalesPerformService}/survey/export-survey-topic`, param).then(res=>{
        this.fullscreenLoading = false;
        let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        let fileName = `${surveyItem.surveyTitle || '问卷题目'}_题目表_${this.$moment(new Date()).format('YYYYMMDDHHmmss')}`;
        let objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a')
        link.download = fileName;
        link.href = objectUrl;
        link.click();
      })
    },
    //下载文件/模板
    downloadFile(url, type, state) {
      if (type == 1 && state == 1) {
        this.$message.error(messageConfig.IMPORT_HANDLE);
        return
      }
      if (!url) {
        this.$message.error(messageConfig.IMPORT_FILE_BROKEN);
        return
      }
      // type为1下载文件 2为异常数据下载文件 不为1下载模板
      window.open(url);
    },
    //预览问卷
    previewSurey(){
      if(!this.taskGuid){
        this.$message.error('请选择任务')
        return
      }else if(!this.surveyGuid){
        this.$message.error('请选择问卷')
        return
      }else{
        let surveyData = '';
        this.surveyList.forEach(i=>{
          if(i.guid == this.surveyGuid){
            surveyData = i;
          }
        })
        sessionStorage.setItem('surveyData',JSON.stringify(surveyData))
        window.open('/surveyPreview')
        // this.$router.push('')
      }
    },
    //获取任务
    getTaskList() {
      let self = this;
      let query = {
        tenantGuid: localStorage.guid,
        pageIndex:1,
        pageSize: -1,
        staffGuid: this.$route.query.guid?JSON.parse(localStorage.userInfo).staffGuid:null,
        taskContentType: ['WJDC'],
      }
      let url = '';
      if(this.$route.query.guid){
        url = '/task/data/get/staff';
      }else{
        url = '/task/data/get/tenant-task-detail-list';
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}${url}`, query).then((res) => {
        this.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.taskList = res.data.data&&res.data.data.records ? res.data.data.records : [];
          if(this.$route.query.guid&&this.taskList.length>0){
            this.taskGuid = this.$route.query.guid;
            this.taskList.forEach(i=>{
              if(this.taskGuid == i.guid){
                this.organisationGuid = i.organisationGuid;
              }
            })
            this.getSurveyList()
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    taskChange(val){
      if(val){
        this.taskList.forEach(i=>{
          if(val == i.guid){
            this.organisationGuid = i.organisationGuid;
            this.taskDetailGuid = i.guid;
          }
        })
        this.surveyGuid = null;
        this.getSurveyList()
      }
    },
    //获取问卷列表
    getSurveyList() {
      let self = this;
      self.tableLoading = true;
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        pageIndex: 1,
        pageSize: -1,
        organisationGuid:this.organisationGuid,
        tenantGuid: localStorage.guid,
        taskDetailGuid:this.$route.query.taskDetailGuid || this.taskDetailGuid
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/survey/staff/get`, query).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data.records){
            self.surveyList = res.data.data.records;
            if(self.surveyList.length == 1){
              self.surveyGuid = self.surveyList[0].guid;
            }
            if(self.$route.query.surveyGuid){
              self.surveyGuid = self.$route.query.surveyGuid;
            }
            self.surveyChange(self.surveyGuid)
          }else{
            self.surveyList =  [];
          }
          
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取核算月
    getCurrentAccountMonth() {
      let self = this;
      let tenantGuid = localStorage.tenantGuid;
      this.Ajax.get(
        `/${serverConfig.msConfigureService}/sysparameter/data/get-account-month?date=` +
          this.getCurrentMonthDay() +
          "&tenantGuid=" +
          tenantGuid
      ).then((resp) => {
        if (resp.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.accountMonth =
            resp.data.substr(0, 4) + "-" + resp.data.substr(4, 2);
          this.getList();
        }
      });
    },
    getCurrentMonthDay() {
      var date = new Date(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day;
    },
    //下载对照表
    uploadExcelArea(){
      window.open('/省市区对照表.xlsx');
    },
    clickSubmit() {
      if (!this.taskGuid) {
        this.$message.error('请选择任务')
        return
      }
      if (!this.surveyGuid) {
        this.$message.error('请选择问卷')
        return
      }
     
    },
    handleClose(done) {
      // this.$confirm('确认关闭？')
      // .then(_ => {
      //   done();
      // })
      // .catch(_ => {});
    },
    toLink(link) {
      this.$router.push({ path: link });
    },
    //导出错误信息
    exportError(){
      this.fullscreenLoading=true
      this.api.get(`/${serverConfig.msSalesPerformService}/survey/import/excel-error-info/get?progressGuid=${this.progressGuid}&hasStaffColumn=${this.hasStaffColumn}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.reportJx(res.data.data.colNames, res.data.data.datas || [], res.data.data.sheetName, res.data.data.fileNam, res.data.data.dataComments||[]);
        } else {
          this.fullscreenLoading=false
          this.$message.error(res.data.msg);
        }
      });
    },
    uploadExcel() {
      if(!this.surveyGuid){
        this.$message.error('请先选择问卷')
        return
      }
      this.fullscreenLoading=true
      this.api.get(`/${serverConfig.msSalesPerformService}/survey/tenant/export/excel-template?surveyTenantGuid=${this.surveyGuid}&hasStaffColumn=${this.hasStaffColumn}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.reportJx(res.data.data.colNames, res.data.data.datas || [], res.data.data.sheetName, res.data.data.fileNam,res.data.data.dataComments||[]);
        } else {
          this.fullscreenLoading=false
          this.$message.error(res.data.msg);
        }
      });
    },
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!');
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    changeFile(file, fileList) {
      let self = this;
      if (fileList.length > 1 && file.status !== "fail") {
        fileList.splice(0, 1);
      }
      let isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        self.$message.error('上传文件大小不能超过 5MB');
        file = null;
        fileList = [];
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
      } else {
        self.fullscreenLoading = true;
        let userInfo = JSON.parse(localStorage.userInfo);
        let taskData = ''
        if(this.taskList.length>0){
          this.taskList.forEach(i=>{
            if(this.taskGuid == i.guid){
              taskData = i
            }
          })
        }
        // if(self.$route.query.guid){
        //   staffGuid
        // }else{
          
        // }
        let extendFields = JSON.stringify({
            taskMainGuid: taskData.taskMainGuid,
            taskDetailGuid:taskData.taskDetailGuid || taskData.guid,
            tenantSurveyGuid:this.surveyGuid,
            staffGuid:userInfo.staffGuid,
            hasStaffCol:self.hasStaffColumn,
          })
        // extendFields 其余字段json
        
        let formData = new FormData();
        formData.append('file', file.raw); //传文件
        formData.append('importType', self.page.importType);
        formData.append('tenantGuid', localStorage.guid);
        formData.append('staffGuid', userInfo.staffGuid);
        formData.append('extendFields', extendFields);
        self.api.postFile(
          self.exportCheckUrl,
          formData,
        )
        .then(function (resp) {
          
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.api.postFile(
                self.exportUrl,
                formData,
            )
            .then(function (res) {
              self.fullscreenLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message({
                  type: 'success',
                  message: messageConfig.UPLOAD_SUCCESS,
                });
                self.getData(1);
                // self.fileList = [];
              } else {
                self.$message({
                  type: 'error',
                  message: res.data.msg,
                });
                return false;
              }
            });
          } else {
            self.fullscreenLoading = false;
            self.$message({
              type: 'error',
              message: resp.data.msg,
            });
            return false;
          }
        });
        
      }
    },
    // changeFile(file, fileList) {
    //   let self = this;
    //   self.num = 0;
    //   let isLt5M = file.size / 1024 / 1024 < 5;
    //   if (!isLt5M) {
    //     self.$message.error('上传文件大小不能超过 5MB');
    //     file = null;
    //     fileList = [];
    //     self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
    //   } else {
    //     let userInfo = JSON.parse(localStorage.userInfo);
    //     let taskData = ''
    //     if(this.taskList.length>0){
    //       this.taskList.forEach(i=>{
    //         if(this.taskGuid == i.guid){
    //           taskData = i
    //         }
    //       })
    //     }
    //     let formData = new FormData();
    //     formData.append('file', file.raw); //传文件
    //     self.progressGuid = self.generateUUID();
    //     let staffGuid = userInfo.staffGuid;
    //     let url = '';
    //     if(self.$route.query.guid){
    //       url = self.url + '&progressGuid=' + self.progressGuid + '&hasStaffColumn=' + self.hasStaffColumn  + '&staffGuid=' + staffGuid +'&tenantSurveyGuid=' + this.surveyGuid + '&taskMainGuid=' + taskData.taskMainGuid + '&taskDetailGuid=' + (taskData.taskDetailGuid || taskData.guid) ;
    //     }else{
    //       url = self.url + '&progressGuid=' + self.progressGuid + '&hasStaffColumn=' + self.hasStaffColumn  + '&tenantSurveyGuid=' + this.surveyGuid + '&taskMainGuid=' + taskData.taskMainGuid + '&taskDetailGuid=' + (taskData.taskDetailGuid || taskData.guid) ;
    //     }
    //     self.intervalSum = setInterval(function () {
    //       self.getImportProgress(self.progressGuid);
    //     }, 1000);
    //     self.api.postFile(url, formData).then(function (res) {
    //       self.fileList = [];
    //       clearInterval(self.intervalSum);
    //       if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //         self.showImport = false;
    //         self.num = 0;
    //         self.$message({
    //           type: 'success',
    //           message: '上传成功',
    //         });
    //         self.active = 1;
    //         if (res.data.data) {
    //           self.dataAllSum = res.data.data.total;
    //           self.dataSuccessSum = res.data.data.ok;
    //           self.dataErrorSum = res.data.data.error;
    //         }
    //       } else {
    //         self.fullscreenLoading = false;
    //         self.showImport = false;
    //         self.num = 0;
    //         self.$message({
    //           type: 'warning',
    //           message: res.data.msg,
    //         });
    //       }
    //     });
    //   }
    // },
    // getImportProgress(progressGuid) {
    //   let self = this;
    //   self.api
    //     .postJson(`/${serverConfig.msCommonAdminCloudService}/excel/import/get-import-progress?guid=` + progressGuid)
    //     .then((res) => {
    //       if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //         if (res.data.data) {
    //           self.num = res.data.data;
    //           if (self.num > 0) {
    //             self.showImport = true;
    //           }
    //         }
    //       } else {
    //         self.$message.error(res.data.msg);
    //       }
    //     });
    // },
    // generateUUID() {
    //   var d = new Date().getTime();
    //   if (window.performance && typeof window.performance.now === 'function') {
    //     d += performance.now(); //use high-precision timer if available
    //   }
    //   var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    //     var r = (d + Math.random() * 16) % 16 | 0;
    //     d = Math.floor(d / 16);
    //     return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    //   });
    //   return uuid;
    // },
    reportJx(colNames, datas, sheetName, fileNam,dataComments) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
          dataComments:dataComments
        })
        .then((res) => {
          this.fullscreenLoading=false
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    //获取状态样式
    getStateClass(state) {
      return importCommon.getImportStateClass(state);
    },
    //禁用导入中状态选项
    selected(row) {
      return importCommon.getDelSelected(row.importState);
    },
    //选择表格数据
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      if (val && val.length > 0) {
        val.forEach(i => {
          self.multipleSelection.push(i.guid);
        });
      }
    },
    //删除
    delFile(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error(messageConfig.DELETE_SELECT);
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm(messageConfig.DELETE_AFTER, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.tableWrapLoading = true;
          self.api
            .postJson(`/${serverConfig.msCommonImportDataService}/import-data/delete`, self.multipleSelection)
            .then(res => {
              self.tableWrapLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success(messageConfig.DELETE_SUCCESS);
                self.getData(1);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: messageConfig.CANCEL_TIP,
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
<style  scoped>
.search-area{
  height:calc(100vh - 60px - 35px - 30px - 110px);
  overflow-y:auto;
  text-align: left;
}
.content-main-box{
  height:calc(100vh - 60px - 72px - 66px - 54px - 110px);
  overflow-y:auto
}
.title-box {
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    display:block;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
/deep/ .el-dialog__header {
  display: none;
}
/deep/ .el-progress__text {
  display: none;
}
/deep/ .el-progress-bar__inner {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #4fa1a4;
  text-align: right;
  border-radius: 100px;
  line-height: 1;
  white-space: nowrap;
  -webkit-transition: width 0.6s ease;
  transition: width 0.6s ease;
}
.summary-text-sty {
  width: 70%;
  /* height: 200; */
  /* border: 2px dashed #b4b4b4; */
  margin: 0 auto;
  /* background: #f7f7f7; */
}
.text-hz {
  margin-top: 36px;
  font-size: 16px;
}
.model-bg {
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  background-color: black;
  z-index: 1001;
  -moz-opacity: 0.6;
  opacity: 0.6;
  filter: alpha(opacity=60);
  color: white;
}
.w145 {
  width: 145px;
}
.search-area-title {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
.importList .select-list {
  display: flex;
  margin-bottom: 20px;
}
.importList .select-list label {
  width: 88px;
  flex-shrink: 0;
  line-height: 36px;
  text-align: right;
  /* width: ; */
}
.importList .select-list label span {
  color: red;
}
.importList .tipInfo {
  line-height: 26px;
  color: #999;
  margin-top: 10px;
  /* padding-left: 77px; */
  box-sizing: border-box;
}
.importList .tipInfo span{
  color: red;
  text-decoration: underline;
  cursor: pointer;
}
.preview-surey{
  color: #4fa1a4;
  line-height: 40px;
  margin-left: 20px;
  cursor: pointer;
  text-decoration: underline;
}
.summary-import-result{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 100px 0 50px 0;
}
.summary-import-result img{
  width: 48px;
  height: 48px;
  margin-right: 20px;
}
.summary-text-sty p{
  margin-bottom: 50px;
  text-decoration: underline;
  cursor: pointer;
}
.close-btn{
  text-align: right;
  margin: 30px 0;
}
.W300{
  width: 300px;
}
</style>